import React from "react";
import { Modal } from "react-bootstrap";
import Alert from "react-bootstrap/Alert";
// import Accordion from 'react-bootstrap/Accordion'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faXmark,
  faCircleInfo,
  faCircleMinus,
  faExclamation,
} from "@fortawesome/free-solid-svg-icons";
import "./ModalSolicitudMedicamento.css";
import { ModalListadoImportados } from "./ModalListadoImportados";
import { useState, useRef, useEffect } from "react";
import { useRut, isValid } from "react-rut";
import { SendGridAdjMulti } from "../../../firebase/firebase-functions";
import { ModalLoading } from "./ModalLoading";
// import Overlay from 'react-bootstrap/Overlay';
// import Popover from 'react-bootstrap/Popover';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { ModalPopUpMensaje } from "./ModalPopUpMensaje";
import { SendGridAdjMulti_V3 } from "../../../firebase/firebase-functions_v3";

export const ModalSolicitudMedicamento = ({
  showModalSolicitudMedicamento,
  handleCloseModalSolicitudMedicamento,
}) => {
  const [telefono, setTelefono] = useState("+56 ");
  const [correo, setCorreo] = useState("");
  const [nombrePac, setNombrePac] = useState("");
  const [detalle, setDetalle] = useState("");
  const [nombreMedicamento, setNombreMedicamento] = useState("");
  const [telefonoError, setTelefonoError] = useState("");
  const [nombreError, setNombreError] = useState("");
  const [rutError, setRutError] = useState("");
  const [correoError, setCorreoError] = useState("");
  const [detalleError, setDetalleError] = useState("");
  const [medicamentoError, setMedicamentoError] = useState("");
  const [{ formattedValue }, setValidRut] = useRut();
  const [rut, setRut] = useState("");
  const [showModalLoading, setShowModalLoading] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [exito, setExito] = useState(false);
  const [errorFallido, setErrorFallido] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertaArchivo, setAlertaArchivo] = useState(false);
  const [recetaError, setRecetaError] = useState(true);
  const [carnetError, setCarnetError] = useState(true);
  const [poderError, setPoderError] = useState(true);
  const [archivosAdjuntos, setArchivosAdjuntos] = useState([]);
  const [mensajeErrorReceta, setMensajeErrorReceta] = useState("");
  const [showModalListadoImportados, setShowModalListadoImportados] =
    useState(false);
  const inputRecetaRef = useRef(null);
  const inputCarnetRef = useRef(null);
  const inputPoderRef = useRef(null);

  const isOnlyNumbers = (str) => {
    return /^\d+$/.test(str);
  };

  const agregarArchivo = (files, id) => {
    // validar que el archivo id 1 se haya cargado
    if (files) {
      if (files.size > 5000000) {
        setExito(false);
        setAlertaArchivo(true);
        setTimeout(() => {
          setAlertaArchivo(false);
        }, 3000);
        if (id === 1) {
          setRecetaError(true);
          inputRecetaRef.current.value = null;
          quitarArchivo(1);
        } else if (id === 2) {
          setCarnetError(true);
          inputCarnetRef.current.value = null;
          quitarArchivo(2);
        } else if (id === 3) {
          setPoderError(true);
          inputPoderRef.current.value = null;
          quitarArchivo(3);
        }
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(files);
        try {
          reader.onloadend = () => {
            let coma = reader.result.indexOf(",") + 1;
            let base64String = reader.result.substring(coma);
            if (id === 1) {
              setRecetaError(false);
            } else if (id === 2) {
              setCarnetError(false);
            } else if (id === 3) {
              setPoderError(false);
            }
            setArchivosAdjuntos((prevState) => {
              const index = prevState.findIndex((item) => item.id === id);
              if (index === -1) {
                return [...prevState, { id, files, base64String }];
              } else {
                const newArray = [...prevState];
                newArray[index] = { id, files, base64String };
                return newArray;
              }
            });
          };
        } catch (error) {
          console.log(error);
        }
      }
    }
  };

  const enviarSolicitud = () => {
    if (
      nombreError ||
      correoError ||
      telefonoError ||
      detalleError ||
      rutError ||
      medicamentoError ||
      recetaError
    ) {
      setExito(false);
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 5000);
      setMensaje("Debe completar los campos correctamente");
    } else {
      setShowModalLoading(true);
      const arrArchivos = [];
      if (archivosAdjuntos.length > 0) {
        archivosAdjuntos.forEach((element) => {
          let objeto = {
            content: element.base64String,
            filename: element.files.name,
            type: element.files.type,
          };
          arrArchivos.push(objeto);
        });
      }
      async function sendMail() {
        const varemailBackOffice = {
          correo: "importaciones@liche.cl", //Correo Destinatario
          subject: "Solicitud de importación", //Asunto del correo
          templateID: "d-971c22c6657a4d10bfd2e3f5e2942329", //Template Dinamico en Sendgrid
          nombre_pac: nombrePac, //Nombre Paciente
          var1: formattedValue, //Variable rut formato 12345678-9
          var2: telefono,
          var3: nombreMedicamento, //Variable nombre medicamento
          var4: correo, //Variable correo paciente
          var5: detalle, //Variable detalle
          arrayAdjuntos: arrArchivos,
        };
        const varemailPaciente = {
          templateID: "d-55dd6fefa1d748b7a5b05923b30ea332", //Template Dinamico en Sendgrid
          correo: correo, //Correo Destinatario
          nombre_pac: nombrePac, //Nombre Paciente
          var1: formattedValue, //Variable
          var2: telefono,
          var3: nombreMedicamento, //Variable
          var4: correo, //Variable
          var5: detalle, //Variable
          arrayAdjuntos: arrArchivos,
        };
        try {
          const responseBackOffice =
            await SendGridAdjMulti_V3(varemailBackOffice);

          if (responseBackOffice.datos !== "sent") {
            setShowModalLoading(false);
            LimpiarCampos();
            setErrorFallido(true);
            return;
          } else {
            const responsePaciente =
              await SendGridAdjMulti_V3(varemailPaciente);
            if (responsePaciente.datos !== "sent") {
              setShowModalLoading(false);
              LimpiarCampos();
              setErrorFallido(true);
              return;
            } else {
              setShowModalLoading(false);
              LimpiarCampos();
              setExito(true);
            }
          }
        } catch (error) {
          console.log(error);
          setShowModalLoading(false);
          LimpiarCampos();
          setErrorFallido(true);
        }
      }

      sendMail();
    }
  };

  const LimpiarCampos = () => {
    setNombrePac("");
    setRut("");
    setValidRut("");
    setRutError("Debe ingresar un rut válido");
    setCorreo("");
    setTelefono("+56 ");
    setDetalle("");
    setNombreMedicamento("");
    setArchivosAdjuntos([]);
    setRecetaError(true);
    inputRecetaRef.current.value = null;
  };

  const validaRut = (rut) => {
    setValidRut(rut);
    if (!isValid(rut)) {
      setRutError("Debe ingresar un rut válido");
    } else {
      setRutError("");
    }
  };

  const verListado = () => {
    setShowModalListadoImportados(true);
  };

  const quitarArchivo = (id) => {
    if (id === 1) {
      // recorrer el array de archivos adjuntos y eliminar el que tenga id 1
      const newArray = archivosAdjuntos.filter((item) => item.id !== 1);
      setArchivosAdjuntos(newArray);
      setRecetaError(true);
      inputRecetaRef.current.value = null;
    } else if (id === 2) {
      const newArray = archivosAdjuntos.filter((item) => item.id !== 2);
      setArchivosAdjuntos(newArray);
      inputCarnetRef.current.value = null;
      setCarnetError(true);
    } else if (id === 3) {
      const newArray = archivosAdjuntos.filter((item) => item.id !== 3);
      setArchivosAdjuntos(newArray);
      inputPoderRef.current.value = null;
      setPoderError(true);
    }
  };

  useEffect(() => {
    if (nombrePac.length <= 5) {
      setNombreError("Debe ingresar un nombre válido");
    } else {
      setNombreError("");
    }
  }, [nombrePac]);

  useEffect(() => {
    if (!isValid(rut)) {
      setRutError("Debe ingresar un rut válido");
    } else {
      setRutError("");
    }
  }, [rut]);

  useEffect(() => {
    const validateEmail = () => {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

      if (!emailRegex.test(correo)) {
        setCorreoError("Debe ingresar un correo válido");
      } else {
        setCorreoError("");
      }
    };
    validateEmail();
  }, [correo]);

  useEffect(() => {
    if (telefono.length !== 13 || !isOnlyNumbers(telefono.substring(4))) {
      //revisar
      setTelefonoError("Debe ingresar un telefono válido");
    } else {
      setTelefonoError("");
    }
  }, [telefono]);

  useEffect(() => {
    if (
      !nombreMedicamento ||
      nombreMedicamento === undefined ||
      nombreMedicamento === ""
    ) {
      setMedicamentoError("Debe ingresar un medicamento válido");
    } else {
      setMedicamentoError("");
    }
  }, [nombreMedicamento]);

  useEffect(() => {
    if (detalle.length < 10 || detalle.length > 300) {
      setDetalleError("Debe escribir mínimo 10 y máximo 300 caracteres");
    } else {
      setDetalleError("");
    }
  }, [detalle]);

  useEffect(() => {
    if (recetaError === true) {
      setMensajeErrorReceta("Debe adjuntar una receta válida");
    } else {
      setMensajeErrorReceta("");
    }
  }, [recetaError]);

  if (exito && !showModalLoading) {
    return (
      <ModalPopUpMensaje
        mostrarBtn={true}
        showModalPopUpMensaje={exito}
        handleCloseModalPopUpMensaje={handleCloseModalSolicitudMedicamento}
        imagen="/correo-electronico.png"
        titulo="Formulario enviado"
        mensaje="Hemos recibido su solicitud de importación con exito, pronto nos pondremos en contacto con usted."
      />
    );
  } else if (errorFallido && !showModalLoading) {
    return (
      <ModalPopUpMensaje
        showModalPopUpMensaje={errorFallido}
        handleCloseModalPopUpMensaje={handleCloseModalSolicitudMedicamento}
        imagen="/mensaje-fallido.png"
        titulo="Error al enviar"
        mensaje="Ha ocurrido un error al enviar sus solicitud, favor comuníquese con nosotros."
      />
    );
  } else {
    return (
      <Modal
        className="text-center"
        show={showModalSolicitudMedicamento}
        onHide={handleCloseModalSolicitudMedicamento}
        size="lg"
        centered={true}
      >
        <Modal.Header className="header-modal">
          <div className="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10  text-start">
            <Modal.Title style={{ fontSize: "1.2rem" }}>
              Solicitud de importación
            </Modal.Title>
          </div>
          <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 text-end">
            <FontAwesomeIcon
              icon={faXmark}
              size="xl"
              onClick={handleCloseModalSolicitudMedicamento}
              className="icon-ficha"
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="container text-start ps-3 pe-3">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 text-center pt-3 pb-3">
              <p>
                Si deseas que importemos fármacos no disponibles en Chile,
                puedes solicitarlo a través de este formulario. En breve nos
                contactaremos contigo.
              </p>
              <h6>
                {" "}
                <button className="boton-lista" onClick={verListado}>
                  Revisa aquí
                </button>{" "}
                Listado de últimos medicamentos importados
              </h6>

              {/* <button className='boton-solicitud lista-modal' onClick={enviarSolicitud} >Listado de medicamentos importados</button> */}
            </div>

            <form>
              <div className="row">
                <div className="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                  <label className="form-label pb-2 ">
                    Ingrese su nombre completo:
                  </label>
                  <input
                    type="text"
                    className={`input-modal ${nombreError ? "input-error" : "input-valido"}`}
                    id="nombre"
                    placeholder="Nombre"
                    value={nombrePac}
                    onChange={(value) => setNombrePac(value.target.value)}
                  />
                  {nombreError ? (
                    <p className="mensaje-error">{nombreError}</p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                  <label className="form-label pb-2 ">Ingrese su rut:</label>
                  <input
                    type="text"
                    className={`input-modal ${rutError ? "input-error" : "input-valido"}`}
                    id="nombre"
                    placeholder="Rut"
                    maxLength={12}
                    value={formattedValue}
                    onChange={(e) => validaRut(e.target.value)}
                  />
                  {rutError ? <p className="mensaje-error">{rutError}</p> : ""}
                </div>
              </div>
              <div className="row">
                <div className="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                  <label className="form-label pb-2">Ingrese su email:</label>
                  <input
                    type="email"
                    className={`input-modal ${correoError ? "input-error" : "input-valido"}`}
                    id="email"
                    placeholder="Correo"
                    value={correo}
                    onChange={(value) => setCorreo(value.target.value)}
                  />
                  {correoError ? (
                    <p className="mensaje-error">{correoError}</p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                  <label className="form-label pb-2">
                    Ingrese número de contacto:
                  </label>
                  <input
                    placeholder="Teléfono"
                    className={`input-modal ${telefonoError ? "input-error" : "input-valido"}`}
                    value={telefono}
                    onChange={(value) =>
                      setTelefono("+56 " + value.target.value.substring(4))
                    }
                    maxLength={13}
                  />

                  {telefonoError ? (
                    <p className="mensaje-error">{telefonoError}</p>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="mb-4 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                <label className="form-label pb-2">
                  Medicamento solicitado:
                </label>
                <input
                  type="text"
                  className={`input-modal ${medicamentoError ? "input-error" : "input-valido"}`}
                  id="medicamento"
                  placeholder="Medicamento"
                  onChange={(value) => setNombreMedicamento(value.target.value)}
                  value={nombreMedicamento}
                />
                {medicamentoError ? (
                  <p className="mensaje-error">{medicamentoError}</p>
                ) : (
                  ""
                )}
              </div>
              <div className="row">
                <div
                  className={
                    recetaError
                      ? "mb-4 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
                      : "mb-4 col-11 col-sm-11 col-md-11 col-lg-11 col-xl-11 col-xxl-11"
                  }
                >
                  <label className="form-label">Subir Receta:</label>
                  <input
                    className="form-control"
                    type="file"
                    ref={inputRecetaRef}
                    accept="image/png, image/jpeg, image/jpg, image/bmp, .pdf"
                    id="formFile"
                    onChange={(e) => agregarArchivo(e.target.files[0], 1)}
                  />
                  {recetaError ? (
                    <p className="mensaje-error">{mensajeErrorReceta}</p>
                  ) : (
                    ""
                  )}
                </div>
                {recetaError ? null : (
                  <div className="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 col-xxl-1 d-flex align-items-center">
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="tooltip-disabled">Quitar archivo</Tooltip>
                      }
                    >
                      <FontAwesomeIcon
                        icon={faCircleMinus}
                        onClick={() => quitarArchivo(1)}
                        className="icon-borrar"
                      />
                    </OverlayTrigger>
                  </div>
                )}
              </div>
              {alertaArchivo ? (
                <div className="text-center alerta-archivo" role="alert">
                  <FontAwesomeIcon icon={faExclamation} className="pe-3" />
                  <span>Archivo no puede pesar mas de 5 Mb.</span>
                </div>
              ) : null}

              {/* <div className="mb-4 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>¿Qué otros documentos debo adjuntar?
              <div 
                  
                  ref={ref}  
                  >
                    <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip-disabled">Más información</Tooltip>}>
              <FontAwesomeIcon onClick={handleClickInfo} icon={faCircleInfo} className={`info-soli ${windowWidth < 576 ? 'pe-2' : 'ps-2'}`}/>
              </OverlayTrigger>
              <Overlay
                      show={show}
                      target={target}
                      placement={windowWidth < 576 ? "top" : "right"}
                      container={ref}
                      containerPadding={20}
                    >
                      <Popover id="popover-contained">
                      <Popover.Header as="h3" bsPrefix='titulo-pop'>¿Qué significa esto?</Popover.Header>
                      <Popover.Body>
                        <p>Si usted ya ha realizado importaciones con nosotros previamente, favor adjunte cédula de identidad y poder simple, de lo contrario solo adjunte receta.</p>
                      </Popover.Body>
                      </Popover>
                    </Overlay>
                    </div>
              </Accordion.Header>
              <Accordion.Body>
        <div className="row">
        <div className={carnetError ? "mb-4  col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" :"mb-4  col-10 col-sm-10 col-md-11 col-lg-11 col-xl-11 col-xxl-11"}>
            <label className="form-label">Subir Cédula de Identidad(CI):</label>
            <input className="form-control" ref={inputCarnetRef} accept='image/png, image/jpeg, image/jpg, image/bmp, .pdf' type="file" id="formFile" onChange={(e) => agregarArchivo(e.target.files[0], 2)} />
        </div>
        {
            carnetError ? null :
            <div className="mt-1 col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 col-xxl-1 d-flex align-items-center">
              <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip-disabled">Quitar archivo</Tooltip>}>
            <FontAwesomeIcon icon={faCircleMinus} onClick={() => quitarArchivo(2)} className='icon-borrar'/>
            </OverlayTrigger>
          </div>
        }
       
        </div>
        <div className="row">
          <div className={poderError ? " col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 col-xxl-8 " :" col-10 col-sm-10 col-md-7 col-lg-7 col-xl-7 col-xxl-7 "} >
              <label className="form-label">Subir poder simple:</label>
              <input className="form-control" ref={inputPoderRef} accept='image/png, image/jpeg, image/jpg, image/bmp, .pdf' type="file" id="formFile" onChange={(e) => agregarArchivo(e.target.files[0],3)} />
          </div>
          {
            poderError ? null :
          <div className="mt-4 col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 col-xxl-1 d-flex align-items-center">
            <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip-disabled">Quitar archivo</Tooltip>}>
          <FontAwesomeIcon icon={faCircleMinus} onClick={() => quitarArchivo(3)} className='icon-borrar'/>
          </OverlayTrigger>
        </div>
          }
          <div className={windowWidth > 576 ? "boton-div col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4" : "col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 py-3" }>
            <button className='boton-poder' onClick={DescargarArchivo} >Descargar poder simple</button>
          </div>
        </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div> */}
              <div className="mb-3">
                <label className="form-label pb-2">Detalle solicitud:</label>
                <textarea
                  className={`input-modal ${detalleError ? "input-error" : "input-valido"}`}
                  id="mensaje"
                  rows="3"
                  value={detalle}
                  onChange={(value) => setDetalle(value.target.value)}
                  maxLength={300}
                  placeholder=""
                ></textarea>
                {detalleError ? (
                  <p className="mensaje-error">{detalleError}</p>
                ) : (
                  ""
                )}
              </div>
              <div className="text-center alerta-soli" role="alert">
                <FontAwesomeIcon icon={faCircleInfo} className="pe-3" />
                <span>
                  Se le hará llegar a su correo una cotización del medicamento
                  solicitado.
                </span>
              </div>
            </form>
            <div className="mb-2 pt-3 text-center">
              <Alert
                variant="warning"
                className="alerta-modal"
                show={showAlert}
              >
                <p>{mensaje}</p>
              </Alert>
              <button
                className="boton-solicitud enviar-modal"
                onClick={enviarSolicitud}
              >
                Enviar solicitud
              </button>
              {showModalListadoImportados ? (
                <ModalListadoImportados
                  showModalListadoImportados={showModalListadoImportados}
                  handleCloseModalListadoImportados={() =>
                    setShowModalListadoImportados(!showModalListadoImportados)
                  }
                />
              ) : null}

              {showModalLoading ? (
                <ModalLoading showModalLoading={showModalLoading} />
              ) : null}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
};
